module.exports = "<section><img class=\"large\" src=\"https://media.giphy.com/media/brGJn738IBzzy/giphy.gif\"/><h1>Thank You!</h1><h3>Follow me! @sheetsj</h3><a class=\"citation\" href=\"https://media.giphy.com/media/brGJn738IBzzy/giphy.gif\" target=\"_blank\">https://media.giphy.com/media/brGJn738IBzzy/giphy.gif</a></section>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/06-thanks/06-thanks.pug
// module id = 136
// module chunks = 1